export default __webpack_public_path__ + "static/media/Metal.c1f75159.png";